import * as moment from "moment";

export const coiCreator = (values) => {
    let date = [];
    // @ts-ignore
    date.push(moment(values.exp_date));
    // @ts-ignore
    date.push(moment(values.umbexp_date));
    // @ts-ignore
    date.push(moment(values.worexp_date));
    // @ts-ignore
    date = moment.min(date).format("YYYY-MM-DD");
    return [
        {
            // @ts-ignore
            cois_id: values.cois_id,
            // @ts-ignore
            property_id: values.property_id.value,
            // @ts-ignore
            vendor_category_id: values.vendor_category_id.value,
            // @ts-ignore
            insured: values.insured,
            // @ts-ignore
            certificate_holder: values.certificate_holder,
            // @ts-ignore
            each_occurence: +values.each_occurence ? +values.each_occurence.replace('$', '').replace(/,/g, '') : 0,
            // @ts-ignore
            damage_to_rented_premises: +values.damage_to_rented_premises ? +values.damage_to_rented_premises.replace('$', '').replace(/,/g, '') : 0,
            // @ts-ignore
            med_exp: +values.med_exp ? +values.med_exp.replace('$', '').replace(/,/g, '') : 0,
            // @ts-ignore
            personal_adv_injury: +values.personal_adv_injury ? +values.personal_adv_injury.replace('$', '').replace(/,/g, '') : 0,
            // @ts-ignore
            products_comp: +values.products_comp ? +values.products_comp.replace('$', '').replace(/,/g, '') : 0,
            // @ts-ignore
            general_liability_exp_date: date,
            // @ts-ignore
            combined_single_limit: 45454,
            // @ts-ignore
            general_aggregate: +values.general_aggregate ? +values.general_aggregate.replace('$', '').replace(/,/g, '') : 0,
            // @ts-ignore
            bodily_injury_per_person: +values.bodily_injury_per_person ? +values.bodily_injury_per_person.replace('$', '').replace(/,/g, '') : 0,
            // @ts-ignore
            bodily_injury_per_accident: +values.bodily_injury_per_accident ? +values.bodily_injury_per_accident.replace('$', '').replace(/,/g, '') : 0,
            // @ts-ignore
            property_damage_per_accident: +values.property_damage_per_accident ? +values.property_damage_per_accident.replace('$', '').replace(/,/g, '') : 0,
            // @ts-ignore
            each_occourrence_umbrella: +values.each_occourrence_umbrella ? +values.each_occourrence_umbrella.replace('$', '').replace(/,/g, '') : 0,
            // @ts-ignore
            aggregate: +values.aggregate ? +values.aggregate.replace('$', '').replace(/,/g, '') : 0,
            // @ts-ignore
            each_accident: +values.each_accident ? +values.each_accident.replace('$', '').replace(/,/g, '') : 0,
            // @ts-ignore
            disease_ea_employee: +values.disease_ea_employee ? +values.disease_ea_employee.replace('$', '').replace(/,/g, '') : 0,
            // @ts-ignore
            disease_policy_limit: +values.disease_policy_limit ? +values.disease_policy_limit.replace('$', '').replace(/,/g, '') : 0,
            authorized_representative: 0,
            // @ts-ignore
            image_path: values.image_path
        }
    ];
};
export const coiValuesCreator = (d,prop,vendor) => {
    return  {
        cois_id: d[0].id,
        property_id: prop && {
            value: prop[0].property,
            label: prop[0].property_name
        } || {value: 0, label: ''},
        vendor_category_id: vendor && {
            value: vendor[0].id,
            label: vendor[0].name
        } || {value: 0, label: ''},
        insured: d[0].data[0].insured,
        authorized_representative: 1,
        image_path: d[0].data[6].image,
        certificate_holder: d[0].data[1].certificate_holder,
        exp_date: d[0].data[3].automobile_liability[0].exp_date,
        bodily_injury_per_person: d[0].data[3].automobile_liability[1] ? d[0].data[3].automobile_liability[1].bodily_injury_per_person : '',
        bodily_injury_per_accident: d[0].data[3].automobile_liability[2] ? d[0].data[3].automobile_liability[2].bodily_injury_per_accident : '',
        property_damage_per_accident: d[0].data[3].automobile_liability[3] ? d[0].data[3].automobile_liability[3].property_damage : '',
        each_occurence: d[0].data[2][0].commercial_general_liability.each_occurance,
        damage_to_rented_premises: d[0].data[2][1][0].damage_to_rented,
        med_exp: d[0].data[2][1][1].med_exp === 'EXCLUDED' ? '0' : d[0].data[2][1][1].med_exp,
        personal_adv_injury: d[0].data[2][1][2].personal_adv,
        general_aggregate: d[0].data[2][1][3].general_aggregate,
        products_comp: d[0].data[2][1][4].products_comp,
        worexp_date: d[0].data[5].workers_compensation[0].exp_date,
        each_accident: d[0].data[5].workers_compensation[1].el_each_accident,
        disease_ea_employee: d[0].data[5].workers_compensation[2] ? d[0].data[5].workers_compensation[2].el_disease_ea_employee : '',
        disease_policy_limit: d[0].data[5].workers_compensation[3] ? d[0].data[5].workers_compensation[3].el_disease_policy_limit : '',
        aggregate: d[0].data[4][0].umbrella_liability[0].aggregate,
        umbexp_date: d[0].data[4][1].exp_date,
        each_occourrence_umbrella: d[0].data[4][2].each_occurance,
        submitted: false,
        next_invoice: false,
        prev_invoice: false,
    };
};




// WEBPACK FOOTER //
// ./src/components/Cois/helpers.tsx